import { Paper } from '@mui/material';
import EventNoteIcon from '@mui/icons-material/EventNote';
import DateRangeIcon from '@mui/icons-material/DateRange';

interface HolidayPeriod {
  name: string;
  start: string; // ISO date
  end: string;   // ISO date
}

interface HolidayCardProps {
  period: HolidayPeriod;
}

const formatDate = (iso: string) => {
  try {
    const d = new Date(iso);
    return d.toLocaleDateString('fr-FR', { day: '2-digit', month: '2-digit', year: 'numeric' });
  } catch (e) {
    return iso;
  }
};

export function HolidayCard(props: HolidayCardProps) {
  const { period } = props;

  return (
    <Paper className="rounded shadow p-4 flex flex-col gap-2 bg-gradient-to-r from-blue-700 to-blue-900 text-white">
      <span className="font-bold text-lg flex items-center gap-2">
        <EventNoteIcon />
        {period.name}
      </span>
      <span className="flex items-center gap-2">
        <DateRangeIcon />
        <span>{formatDate(period.start)} — {formatDate(period.end)}</span>
      </span>
      <span className="text-sm opacity-80">
        🎓 Période scolaire
      </span>
    </Paper>
  );
}

export default HolidayCard;
